import { constant, pipe } from "fp-ts/function";
import {
  TextChildren,
  InlineMessage,
  LocalizedString,
  useIsMobileLayout,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { Option } from "fp-ts/Option";
import { useFormatDate } from "../../intl";
import { ComponentProps } from "react";
import { ReadOnlyTextField } from "../ReadOnlyTextField/ReadOnlyTextField";
import { ReadOnlyFieldToValue } from "../ReadOnlyField/ReadOnlyFieldToValue";

type Props = {
  id?: string;
  value: Option<Date>;
  label: TextChildren;
  format: "mm-yyyy" | "dd-mm-yyyy";
  feedback?: {
    type: ComponentProps<typeof InlineMessage>["type"];
    message: LocalizedString;
  };
  text?: boolean;
  labelSize?:
    | "xx-small"
    | "x-small"
    | "small"
    | "medium"
    | "large"
    | "big"
    | "x-large";
  labelWeight?: "medium" | "regular" | "bold";
  color?: string;
};

export function ReadOnlyDateField(props: Props) {
  const formatDate = useFormatDate(props.format);
  const isMobileLayout = useIsMobileLayout();
  return isMobileLayout && props.text ? (
    <ReadOnlyTextField
      label={props.label}
      value={unsafeLocalizedString(
        pipe(props.value, option.fold(constant("-"), formatDate))
      )}
      size={"small"}
      feedback={props.feedback}
    />
  ) : (
    <ReadOnlyFieldToValue
      labelSize={
        props.labelSize ? props.labelSize : isMobileLayout ? "small" : "x-small"
      }
      labelWeight={props.labelWeight ? props.labelWeight : "bold"}
      {...props}
      size="medium"
      value={pipe(props.value, option.fold(constant("-"), formatDate))}
    />
  );
}
